<script setup>

import { computed } from "vue";
import { useI18n } from 'vue-i18n';
const { t } = useI18n();
const props = defineProps({
  invoices: Object,
  documents: Object,
});

const hasDocuments = computed(() => {
  return (props.documents && Object.keys(props.documents).length > 0) || 
         (props.invoices && Object.keys(props.invoices).length > 0);
});

</script>

<template>
    <div  v-if="hasDocuments" class="workfile-document">
        <hr class="separator-mobile"/>
        <div class="workfile-document-title">
            <span class="subtitle" style="font-weight: bold;">{{ t('workfiles.tabs.files')}}</span>
        </div>
        <div class="workfile-invoice-content">
            <div class="workfile-document-list">
                <a v-for="document in props.documents" :href="document.link" target="_blank" style="font-size: 25px;">
                    <img src="/assets/svg/pdf.svg"/>
                </a>
                <a v-for="document in props.invoices" :href="document.link" target="_blank" style="font-size: 25px;">
                    <img src="/assets/svg/factura.svg"/>
                </a>
            </div>
        </div>
        <div class="workfile-document-content">
            <div class="workfile-document-list">
                
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
// .workfile-document-title{
//     display: none;
// }
.subtitle{
    font-family: 'CircularStd-Bold';
    color: #153440;
    opacity: 1;
    font-size: 18px;
    // font-weight: bold;
}
.workfile-document-list{
    padding-left: 0 !important;
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin-top: 2px;
}
.separator-mobile{
    margin-top: 20px;
    color: inherit;
    border: 0;
    border-top: 1px solid;
    opacity: 0.25;
    margin-bottom: 20px;
    justify-self:center;
    width: calc(100% + 40px); 
    margin-left: -20px; 
    margin-right: -20px; 
    
    
    
}
// Contemplar si son massa grans els arxius, cambiar aqui la mida
// img{
//     height: 30px;
//   }

</style>